export function sanitizeTextInput(value: string, maxLength: number): string {
  const trimmed = value.trim()
  return trimmed.slice(0, maxLength)
}

export function sanitizeEmailInput(value: string, maxLength = 254): string {
  return sanitizeTextInput(value.toLowerCase(), maxLength)
}

export function sanitizePasswordInput(value: string, maxLength = 128): string {
  return sanitizeTextInput(value, maxLength)
}
